// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__3wzDu","section":"Layout_section__3UnqA"};